export interface GetAntrepoInListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetAntrepoInListPagingAndFilterResponseData
}

export interface GetAntrepoInListPagingAndFilterResponseData {
    items: GetAntrepoInListPagingAndFilterResponseItem[]
    totalRecordCount: number
    totals: GetAntrepoInListPagingAndFilterResponseTotals | undefined
}

/** Görüntülenen sayfadaki kayıtların dip toplamı. */
export interface GetAntrepoInListPagingAndFilterResponseTotals {
    declarationPotQuantity: number
    declarationPotWeight: number
    totalPotQuantity: number
    totalGrossWeight: number
    waitingTotalPotQuantity: number
    waitingTotalGrossWeight: number
    stockTotalPotQuantity: number
    stockTotalGrossWeight: number
    rowCount: number
}

export interface GetAntrepoInListPagingAndFilterResponseItem {
    antrepoInId: string
    companyId: string
    ledgerNo: string
    freeStorageRefNo: string
    antrepoDeclarationNo: string
    antrepoDeclarationDate: string
    goodsAmount: number
    goodsAmountCurrencyTypeId: string
    guaranteeAmount: number
    guaranteeAmountCurrencyTypeId: string
    saleTypeId?: string
    guaranteeTypeId: string
    antrepoEnteranceDate?: string
    storageEnteranceDate?: string
    goodsAmountCurrencyTypeName: string
    guaranteeAmountCurrencyTypeName: string
    saleTypeName?: string
    guaranteeTypeName: string
    senderFirmId?: string
    receiverFirmId?: string
    dutyFirmId?: string
    customsDirectorateId?: string
    exitCountryId?: string
    representativeId?: string
    senderFirmName?: string
    receiverFirmName?: string
    dutyFirmName?: string
    customsDirectorateName?: string
    exitCountryName?: string
    representativeName?: string
    transferFirmId?: string
    transferAntrepoDeclarationNo?: string
    transferAntrepoDeclarationDate?: string
    transferInvoice?: string
    transferFirmName?: string
    antrepoInVehicles: GetAntrepoInListPagingAndFilterResponseAntrepoInVehicle[]
    antrepoInVehicleProducts: GetAntrepoInListPagingAndFilterResponseAntrepoInVehicleProduct[]
    antrepoInVehicleServices: GetAntrepoInListPagingAndFilterResponseAntrepoInVehicleService[]
    fileArchives: GetAntrepoInListPagingAndFilterResponseFileArc[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
    isRedrese: boolean
    transferAntrepoOutId: string | undefined
    // Araçlar alt tablosundan birleşik kolonlar (tekrarsız, ", " ile ayrılmış).
    vehiclePlates?: string
    trailerPlates?: string
    supplierNames?: string
    antrepoEnteranceDatesStr?: string
    containerNos?: string
    transportDocumentNos?: string
    truckReportNos?: string
    summaryDeclarationNos?: string
}

export interface GetAntrepoInListPagingAndFilterResponseAntrepoInVehicle {
    antrepoInVehicleId: string
    antrepoInId: string
    groupNo: number
    vehicleId: string
    trailerId: any
    containerNo: any
    containerId: any
    vehicleArriveDate: any
    supplierId: any
    transportDocumentNo: any
    truckReportNo: any
    summaryDeclarationNo: any
    summaryDeclarationDate: any
    antrepoEnteranceDate: any
    summaryDeclarationOrderNo: any
    summaryDeclarationOrderQuantity: any
    trailerName: any
    containerName: any
    supplierName: any
    vehicleName: any
}

export interface GetAntrepoInListPagingAndFilterResponseAntrepoInVehicleProduct {
    antrepoInVehicleProductId: string
    antrepoInVehicleId: string
    groupNo: number
    gTipId?: string
    gTipName?: string
    productTypeId: string
    potQuantity: any
    grossWeight: any
    netWeight: any
    volume: any
    area: any
    productTypeName: string
    productName: string
}

export interface GetAntrepoInListPagingAndFilterResponseAntrepoInVehicleService {
    antrepoInVehicleServiceId: string
    antrepoInVehicleId: string
    groupNo: number
    serviceId: string
    quantity: number
    multiplierId: string
    serviceName: string
    multiplierName: string
}

export interface GetAntrepoInListPagingAndFilterResponseFileArc {
    fileArchiveId: string
    entityId: string
    fileName: string
    url: string
    fileTypeId: string
    description: string
    fileTypeName: string
    createdDate: string
}

export const initialGetAntrepoInListPagingAndFilterResponseData: GetAntrepoInListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0,
    totals: undefined
}